import styles from './TableCardView.module.scss';
import { Collapse, Input, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import type { TableColumnType } from '../Table';
import { ResetFiltersButton } from '../ResetFiltersButton';
import type { CardFilterState } from './TableCardViewControls';
import { getColumnKey, getColumnLabel } from './tableCardViewUtils';

interface Props<T> {
  columns: TableColumnType<T>[];
  filters: CardFilterState;
  onFiltersChange: (filters: CardFilterState) => void;
}

export function TableCardViewFilterControls<T>(props: Props<T>) {
  const { columns, filters, onFiltersChange } = props;
  const { t } = useTranslation();

  const onFilterValueChange = (key: string, value: string) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  const resetFilters = () => onFiltersChange({});

  return (
    <Collapse ghost className={styles.filters}>
      <Collapse.Panel key="filters" header={t('table.filters')}>
        <Space direction="vertical" size="small" className="w-100">
          {columns.map((column, index) => {
            const key = getColumnKey(column, index);
            return (
              <Input
                key={key}
                placeholder={getColumnLabel(column)}
                value={filters[key] ?? ''}
                onChange={(e) => onFilterValueChange(key, e.target.value)}
                allowClear
              />
            );
          })}
          <div className={styles.resetFilters}>
            <ResetFiltersButton handleReset={resetFilters} />
          </div>
        </Space>
      </Collapse.Panel>
    </Collapse>
  );
}
